import React, { Fragment } from 'react'
import styled from 'styled-components';
import {Block, BlockStyle} from './Block';
import StoreController from '../../StoreController';
import Spinner from "../../Components/Common/Spinner/Spinner";
import { api } from '../../utils/api';
import { API_PAGES, API_ZAPIER, API_STRIPE } from '../../Constants';
import { rxProjectId, rxPageId, rxProducts, eventEmiter } from '../../rx/rxState';

const ButtonStyle = styled.div`
    position: relative;
    // vertical-align: middle;
    // height: 100%;
    // pointer-events: auto;
`

const LoadingStyle = styled.div`
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
`

export class BlockButtonProxy extends React.Component {
    constructor(props) {
        super(props);
        this.targetType = props.targetType;
        this.state = {
            loading: false
        }
    }
    onChange( editorState ){
        this.setState({content: editorState})
        this.props.onChange( editorState );
    }

    componentDidMount(){
        this.props.reference.current.style.cssText = this.props.styleText;
    }
    componentDidUpdate(prevProps){
        if(prevProps.styleText !== this.props.styleText){
            this.props.reference.current.style.cssText = this.props.styleText;
        }
    }
    onFormCallback(status, error, mode){
        if(error){
            this.setState({loading: false});
        }
        if(status && !error){
            if(mode === 'stripe'){
                let formData = JSON.parse(localStorage.getItem('key'));
                this.sendCustomerData(formData, (status, error)=>this.onFormCallback(status, error));
            }

            this.nextPage();
        }
    }

    nextPage(){
        console.log('destination', this.props.destination);
        if(this.props.destination.value == 'popup'){
            eventEmiter.next({
                type: 'switch-view-exit-modal'
              });
            this.setState({loading: false})
        }
        else if(this.props.destination.value == 'custom'){
            if(this.props.url.value){
                window.location += this.props.url.value
                
                // this.navigate();
            }
            this.setState({loading: false})
        }
        else if(this.props.destination.value == 'URL'){
            if (this.props.url.value) {
                let url = this.props.url.value;
                if (this.props.url.value.indexOf('https://') === -1 && this.props.url.value.indexOf('http://') === -1) {
                    url = 'https://'+ this.props.url.value;
                }
                
                this.navigate(url);
            }
            this.setState({loading: false})
        }
        else{
            let request = {
                action: 'get-next',
                projectId: rxProjectId.getValue(),
                pageId: rxPageId.getValue(),
            }
            api(API_PAGES, 'POST', request)
            .then( (result) => {
                let url = window.location.href;
                if(result.next){
                    let sliceAmount = -2;

                    let components = url.split('/');
                    if(components[ components.length - 1] != 'optin'){ //TODO remove this dirty hardcoded workaround
                        sliceAmount = -1;
                    }
                    let destination = url.split('/').slice(0,sliceAmount).join('/')+'/'+result.next+'/optin'

                    this.navigate(destination);
                }
                else{
                    this.setState({loading: false})
                }
            });
        }
    }

    navigate(url){
        if (this.targetType.value === 'New Tab') {
            window.open(url, '_blank');
        }
        else if(this.targetType.value === 'Same Page'){
            window.open(url, '_top');
        } else {
            window.open(url);
        }
        this.setState({loading: false})
    }

    onClick(){
        // debugger
        if(StoreController.instance().liveMode === false){
            return;
        }
        let pass = true;
        let formData = [];
        let rootSection = this.props.view.getRootSectionFor(this.props.block);
        let forms = rootSection.getBlocksByType('Form');
        for( let form of forms ){
            if(form.isVisible === false){
                continue;
            }
            let data = form.verifyInput();
            if(data === false){
                pass = false;
            }
            else{
                if(form.formType !== 'Checkbox'){
                    formData.push( data );
                }
            }
        }
        if(!this.props.formValidation){
            pass = true;
        }

        let stripe = this.props.view.getBlocksByType('Stripe');
        for( let form of stripe ){
            if(!form.verifyInput() && pass){
                pass = false;
            }
        }

        if(!pass){
            return;
        }

        //save form data in to cache
        if(formData.length > 0){
            localStorage.setItem('key', JSON.stringify(formData));
        }
        if(stripe.length > 0){
            this.setState({loading: true});
            stripe[0].createPaymentIntent(formData, (status, error)=>this.onFormCallback(status, error, 'stripe'));
        }
        else if(formData.length > 0){
            this.setState({loading: true});
            this.sendCustomerData(formData, (status, error)=>this.onFormCallback(status, error));
        }
        else if( this.props.destination.value==='upsell' ){
            this.setState({loading: true});
            let formData = JSON.parse(localStorage.getItem('key'));

            let dict = {};
            for(const d of formData){
                dict[d.type] = d.value;
            }
            this.sendUpsellData({...dict, productId: this.props.productId}, (status, error)=>this.onFormCallback(status, error, 'stripe'));
        }
        else{
            this.setState({loading: true})
            this.nextPage();
        }
    }


    sendUpsellData(data, callback){
        let request = {
            action: 'upsell',
            projectId: rxProjectId.getValue(),
            ...data
        }
        console.log('request:', request);

        fetch(API_STRIPE+'?action=upsell', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        })
        .then( result => {
            return result.json()
        })
        .then(data=>{
            console.log('data:',data);
            if(data.error){
                callback( false, data.error );
            }
            else{
                callback( true );
            }

        })
        .catch(error => {
            console.log('error', error);
            callback( false, error );
        });
    }

    sendCustomerData(data, callback){
        let dict = {};
        for(let item of data){
            dict[item.type] = item.value;
        }

        let request = {
            firstName: dict.Name,
            firstName: dict.FirstName,
            lastName: dict.LastName,
            email: dict.Email,
            phone: dict.Phone,
            projectId: rxProjectId.getValue(),
            pageId: rxPageId.getValue()
        }

        console.log('sending data', request);

        api(API_ZAPIER+'?action=add-customer', 'POST', request)
        .then( (result) => {
            console.log('result', result);
            if(result.success){
                callback( true );
            }
            else{
                callback( false, result.error );
            }
        })
        .catch(error => {
            console.log('error:', error);
            callback( false, error );
        });
    }

    render(){
        let content = <ButtonStyle>
                    {this.state.loading ?
                        <LoadingStyle>
                            <Spinner size={40}/>
                        </LoadingStyle>
                        :
                        null
                    }
                    <div style={{opacity: this.state.loading ? '0' : '1'}}>
                    {this.props.children}
                    </div>
                </ButtonStyle>
        let output = <BlockStyle
                    id={this.props.id}
                    key={this.props.id}
                    onClick = {this.onClick.bind(this)}
                    width={this.props.width}
                    ref={this.props.reference}>
                        {content}
                    </BlockStyle>
        return output;
        }
}

export class BlockButton extends Block{
    constructor(props){
        super(props);

        this.type = 'Button';

        let attr = {
            id: 'color',
            displayName: 'Color',
            value: null,
            type: 'AttributeColor'
          }
       this.addAttribute( attr );

       attr = {
        id: 'destination',
        displayName: 'Destination',
        value: 'Next Page',
        type: 'AttributeDropdown',
        options: [{
                label: 'Next Page',
                value: 'Next Page'
            },
            {
                label: 'Popup',
                value: 'popup'
            },
            {
                label: '1-Click Upsell',
                value: 'upsell'
            },
            {
                label: 'URL',
                value: 'URL'
            },
            {
                label: 'Custom',
                value: 'custom'
            }],
        }
        this.addAttribute( attr );

        attr = {
            id: 'targetType',
            displayName: 'Open As',
            value: 'Same Page',
            type: 'AttributeDropdown',
            options: [{
                    label: 'Same Page',
                    value: 'Same Page'
                },
                {
                    label: 'New Tab',
                    value: 'New Tab'
                }],
        }
        this.addAttribute( attr );

        attr = {
            id: 'url',
            displayName: '',
            value: '',
            width: 200,
            prefix: '', /* was 'https://'  */
            type: 'AttributeString',
            visible: false
        }
        this.addAttribute( attr );

        attr = {
            id: 'formValidation',
            displayName: 'Forms Validation',
            value: false,
            type: 'AttributeBool',
        }
        this.addAttribute( attr );

        let productOptions = [];
        if(StoreController.instance().liveMode === false){
          const values = rxProducts.getValue() || [];
          for(let product of values){
              productOptions.push({
                  label: product.name,
                  value: product._id
              })
          }
        }
        let attribute = {
            id: 'product',
            displayName: 'Product',
            value: '',
            type: 'AttributeDropdown',
            options: productOptions,
            visible: false
        }

        this.addAttribute( attribute );

    }

    update(){
        super.update();

        if(this.destination.value === 'URL' || this.destination.value == 'custom'){
            this.url.visible = true;
            this.product.visible = false;
        }
        else if(this.destination.value === 'upsell'){
            this.product.visible = true;
            this.url.visible = false;
        }
        else{
            this.url.visible = false;
            this.product.visible = false;
        }
    }

    setEditing( value ) {
        let textBlock = this.children[0];
        if(value){
          this.view.overlay.selectBlock( textBlock );
        }
        textBlock.setEditing( value );
      }

    style(){
        let output = super.style();

        if(this.color.value){
            output += '; background-color: ' + this.color.value + ';';
        }

        if(StoreController.instance().liveMode){
            output += '; cursor: pointer;'
        }

        return output;
    }
    unpack(data){
        super.unpack(data);

        //all children of Button can't be dragged
        for(let child of this.children){
            child.isDraggable = false;
        }
    }
    renderView(){
        return(
        <Fragment key={this.id}>
        { this.isVisible ?
            <>
            { this.isDragging ? this.getPlaceholder()
            :
            <BlockButtonProxy
                id={this.id}
                key={this.id}
                view={this.view}
                reference={this.ref}
                width={this.worldRenderBRect ? this.worldRenderBRect.width : 0}
                styleText={this.style()}
                targetType={this.targetType}
                destination={this.destination}
                productId={this.product.value}
                formValidation={this.formValidation.value}
                block={this}
                url={this.url}
                >
                    {
                        this.children.map((child)=>{
                        return child.renderView();
                        })
                    }
                </BlockButtonProxy>
            }
            </>
        :
        null
        }
        </Fragment>
        )
    }
}
